import { GET_ESTADOS, FETCH_ESTADOS } from "../actions/types.js";

const initialState = {
  estados: [],
  isLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ESTADOS:
      return {
        ...state,
        estados: action.payload,
        isLoading: false,
      };
    case FETCH_ESTADOS:
      return {
        ...state,
        estados: [],
        isLoading: true,
      };
    default:
      return state;
  }
}
